// Regions helper: returns country-grouped regions with id and name only

const regions = {
  USA: [
    { id: "us-east", name: "East US" },
    { id: "us-west", name: "West US" },
    { id: "us-central", name: "Central US" },
    { id: "us-mountain", name: "Mountain US" },
  ],
  Canada: [
    { id: "ca-east", name: "East Canada" },
    { id: "ca-west", name: "West Canada" },
  ],
};

// Default: grouped by country
export default function getRegions() {
  return regions;
}

// Convenience: flattened array [{id,name}, ...]
export function getRegionsFlat() {
  return [...regions.USA, ...regions.Canada];
}

// Convenience: id -> { id, name }
export function getRegionMap() {
  return getRegionsFlat().reduce((acc, r) => {
    acc[r.id] = r;
    return acc;
  }, {});
}
